// extracted by mini-css-extract-plugin
export default {"titleContainer":"_2K6Rd0NF","chevron":"_3XVwM5g1","up":"_1EAkDuDN","xsOnly":"_2f76PJSj","content":"_1VPOSkXL","contentExpanded":"_3uAaZsQH"};